import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { addI18nTranslations } from "../../utils";

export default {
    title:
        "Components/Stateful Filter & Content/Stateful Content/Stateful Tiles",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-stateful-tiles",
    args: {
        scope: "statefultiles",
        url: "generated-mock-data/stateful-content.json",
    },
    argTypes: {
        scope: {
            control: "text",
        },
        url: {
            control: "text",
        },
    },
};

const Template = ({ scope, url }) => {
    addI18nTranslations({
        namespace: "statefultiles",
        language: "de-DE",
        translations: {
            content: {
                isFav: {
                    column: "Translated 1",
                },
                name: {
                    column: "Translated 2",
                },
                latestAvailableVersion: {
                    column: "Translated 3",
                },
                serviceAgreementStatus: {
                    column: "Translated 4",
                },
            },
        },
    });

    return html`<ux-iws-stateful-tiles
        scope="${scope}"
        url="${url}"
    ></ux-iws-stateful-tiles>`;
};

export const Default = Template.bind({});
